import { z } from "zod";

export const signupSchema = z.object({
  accountName: z.string().min(2, "Account name required"),
  email: z.email("Invalid email"),
  password: z.string().min(8, "Min 8 characters"),
});

export const loginSchema = z.object({
  email: z.email("Invalid email"),
  password: z.string().min(8, "Min 8 characters"),
});

const germanPostalCodeRegex = /^\d{5}$/;
const vatIdRegex = /^DE[0-9]{9}$/i;

export const registrationSchema = z
  .object({
    accountName: z
      .string()
      .trim()
      .min(2, "Kontoname ist erforderlich")
      .max(120, "Kontoname ist zu lang"),

    ownerFullName: z
      .string()
      .trim()
      .min(2, "Name ist erforderlich")
      .max(120, "Name ist zu lang"),

    email: z
      .email("Ungültige E-Mail-Adresse")
      .max(200, "E-Mail ist zu lang"),

    password: z
      .string()
      .min(10, "Passwort muss mindestens 10 Zeichen haben")
      .max(200, "Passwort ist zu lang"),

    confirmPassword: z.string().min(1, "Bitte Passwort bestätigen"),

    billingCompanyName: z
      .string()
      .trim()
      .min(2, "Firmenname ist erforderlich")
      .max(160, "Firmenname ist zu lang"),

    billingStreet: z
      .string()
      .trim()
      .min(2, "Straße und Hausnummer sind erforderlich")
      .max(160, "Adresse ist zu lang"),

    billingPostalCode: z
      .string()
      .trim()
      .regex(germanPostalCodeRegex, "PLZ muss 5-stellig sein"),

    billingCity: z
      .string()
      .trim()
      .min(2, "Ort ist erforderlich")
      .max(120, "Ort ist zu lang"),

    billingCountry: z.literal("DE"),

    vatId: z
      .string()
      .trim()
      .optional()
      .or(z.literal(""))
      .refine(
        (value) => !value || vatIdRegex.test(value),
        "USt-IdNr. muss z. B. DE123456789 sein",
      ),

    seatCount: z
      .number({ message: "Anzahl Lizenzen ist erforderlich" })
      .int("Nur ganze Zahlen")
      .min(1, "Mindestens 1 Lizenz")
      .max(500, "Zu viele Lizenzen"),

    preferredPaymentMethod: z.enum(["SEPA", "CARD"], {
      message: "Bitte Zahlungsart auswählen",
    }),

    acceptLegal: z.boolean().refine((v) => v === true, {
      message:
        "Bitte akzeptieren Sie die AGB einschließlich AVV und Nutzungsbedingungen und bestätigen Sie die Kenntnisnahme der Datenschutzhinweise.",
    }),
  })
  .refine((v) => v.password === v.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwörter stimmen nicht überein",
  });

export type RegistrationFormInput = z.input<typeof registrationSchema>;
export type RegistrationFormOutput = z.output<typeof registrationSchema>;
export type SignupForm = z.infer<typeof signupSchema>;
export type LoginForm = z.infer<typeof loginSchema>;
